import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';

export class FascicoloAzioneMonitoria extends FascicoloFull {
  sezione: string;
  numDecretoIngiuntivo: string;
  numRegistroGenerale: string;
  dataEmissioneDecretoIngiuntivo: number;
  dataDepositoDecretoIngiuntivo: number;
  dataRichiestaApposizione: number;
  dataRitiroCopie: number;
  dataApposizioneFormulaEsecutiva: number;
  cancelliere: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
